$(function () {

  /* ---------------------------
   GLOBAL FIXES
  ----------------------------*/
  $("li:first-child").addClass("first");
  $("li:last-child").addClass("last");
  $('[href="#"]').attr("href", "javascript:;");


  /* ---------------------------
   MOBILE MENU
  ----------------------------*/
  $(".menu-Bar").on("click", function () {
    $(this).toggleClass("open");
    $(".menuWrap").toggleClass("open");
    $("body").toggleClass("ovr-hiddn");
  });


  /* ---------------------------
   POPUPS (LOGIN / SIGNUP / CLOSE)
  ----------------------------*/
  $(".loginUp").on("click", function () {
    $(".LoginPopup, .overlay").fadeIn();
  });

  $(".signUp").on("click", function () {
    $(".signUpPop, .overlay").fadeIn();
  });

  $(".closePop, .overlay").on("click", function () {
    $(".popupMain, .overlay").fadeOut();
  });


  /* ---------------------------
   GENERIC TAB SYSTEM
  ----------------------------*/
  $("[data-target]").on("click", function () {
    const target = $(this).data("target");

    $(this).addClass("active").siblings().removeClass("active");

    $("." + target)
      .fadeIn()
      .siblings('[class^="box"]')
      .hide();

    $(".tabViewList").slick("setPosition");
  });


  /* ---------------------------
   ACCORDION (FIXED - SINGLE SYSTEM ONLY)
  ----------------------------*/
  $(document).on("click", ".at-title", function () {
    const parent = $(this).closest(".at-item");

    if (parent.hasClass("active")) {
      parent.removeClass("active").find(".at-tab").slideUp();
    } else {
      $(".at-item.active .at-tab").slideUp();
      $(".at-item").removeClass("active");

      parent.addClass("active").find(".at-tab").slideDown();
    }
  });


  /* ---------------------------
   SEARCH POPUP
  ----------------------------*/
  $(".searchBtn").on("click", function () {
    $(".searchWrap").addClass("active");
    $(".overlay").fadeIn();

    $(".searchWrap input")
      .focus()
      .on("blur", function () {
        $(".searchWrap").removeClass("active");
        $(".overlay").fadeOut();
        $("body").removeClass("ovr-hiddn");
      });
  });


  /* ---------------------------
   SLICK SLIDERS (INIT SAFE)
  ----------------------------*/
  function initSlick(selector, settings) {
    if ($(selector).length && !$(selector).hasClass("slick-initialized")) {
      $(selector).slick(settings);
    }
  }

  initSlick(".index-slider", {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 2,
    arrows: true
  });

  initSlick(".index-slider-news", {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    arrows: true
  });

  initSlick(".testimonials-slider", {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    arrows: true
  });

  initSlick(".clientSlider", {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    autoplay: true,
    arrows: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 600, settings: { slidesToShow: 2 } }
    ]
  });

  initSlick(".clientSlider2", {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    autoplay: true,
    arrows: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 600, settings: { slidesToShow: 2 } }
    ]
  });


  /* ---------------------------
   SYNC SLIDERS
  ----------------------------*/
  initSlick(".slider-for", {
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    arrows: false,
    asNavFor: ".slider-nav"
  });

  initSlick(".slider-nav", {
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: ".slider-for",
    focusOnSelect: false,
    infinite: true,
    vertical: true,
    responsive: [
      { breakpoint: 800, settings: { vertical: false } }
    ]
  });


  /* ---------------------------
   DROPDOWN MENU (OPTIMIZED)
  ----------------------------*/
  const $menuItems = $(".has-child");

  if ($(window).width() > 1200) {
    $menuItems.hover(
      function () {
        $(this).children(".dropdown").stop(true).slideDown(100);
        $(this).find(".chev").addClass("rotate");
      },
      function () {
        $(this).children(".dropdown").stop(true).slideUp(100);
        $(this).find(".chev").removeClass("rotate");
      }
    );
  } else {
    $menuItems.on("click", function () {
      const $dropdown = $(this).children(".dropdown");

      $(".dropdown").not($dropdown).slideUp(100);
      $dropdown.stop(true).slideToggle(100);

      $(".chev").not($(this).find(".chev")).removeClass("rotate");
      $(this).find(".chev").toggleClass("rotate");
    });
  }


  /* ---------------------------
   COUNTER (OPTIMIZED)
  ----------------------------*/
  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "");
  }

  $(window).on("scroll", function () {
    const $goto = $(".goto");

    if ($goto.length && !$goto.hasClass("animated")) {
      if ($(window).scrollTop() >= $goto.offset().top - $(window).height()) {

        $(".count").each(function () {
          $(this).prop("Counter", 0).animate({
            Counter: $(this).text()
          }, {
            duration: 2000,
            step: function (now) {
              $(this).text(numberWithCommas(Math.ceil(now)));
            }
          });
        });

        $goto.addClass("animated");
      }
    }
  });


  /* ---------------------------
   STICKY HEADER
  ----------------------------*/
  $(window).on("scroll", function () {
    $("header").toggleClass("sticky", $(window).scrollTop() > 1);
  });


  /* ---------------------------
   AOS INIT (SAFE)
  ----------------------------*/
  if (typeof AOS !== "undefined") {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true
    });
  }

});